module.exports = __webpack_public_path__ + "img/service-about-3.d0f171b6.jpg";